import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import './index.css';
import App from './components/App';
import * as serviceWorker from './serviceWorker';
import { BrowserRouter as Router } from 'react-router-dom';
import store from './redux/store';
import Modal from 'react-modal';
Modal.setAppElement('#root');

ReactDOM.render(
  <Provider store={store}>
    {/*<ConnectedRouter history={history}>*/}
    <Router>
      <App />
    </Router>
    {/*</ConnectedRouter>*/}
  </Provider>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();
